<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { provide, reactive, toRefs, ref } from '@vue/composition-api'

export default {
  setup() {
    const SYMBOL_KEY = Symbol.for('filter')
    const state = reactive({
      init: false,
      item: null,
      items: ref([]),
    })

    const reset = () => {
      state.init = false
      state.item = null
      state.items = ref([])
    }

    const setItem = item => {
      state.init = true
      state.item = item
      !state.items.includes(item) && state.items.push(item)
    }

    provide(SYMBOL_KEY, {
      reset,
      setItem,
      ...toRefs(state),
    })
    return { items: state.items }
  },
}
</script>
